import { Component, HostBinding, HostListener, Input } from '@angular/core';

@Component({
  selector: 'header-username-tile',
  templateUrl: './header-username-tile.component.html',
  styleUrls: ['./header-username-tile.component.scss'],
})
export class HeaderUsernameTileComponent {
  @Input() displayName = '';

  /** Wired from CoreComponent: opens the same user menu as `horizon-user-avatar` (`.custom-menu-container`). */
  @Input() menuActivator: () => void;

  @HostBinding('attr.data-cp-username-tile') readonly tileMarker = 'true';

  @HostBinding('attr.role') readonly roleAttr = 'button';

  @HostBinding('attr.tabindex') readonly tabIndex = 0;

  @HostListener('click', ['$event'])
  onHostClick(event: MouseEvent): void {
    event.stopPropagation();
    this.menuActivator?.();
  }

  @HostListener('keydown.enter', ['$event'])
  @HostListener('keydown.space', ['$event'])
  onHostKeydown(event: KeyboardEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.menuActivator?.();
  }
}
